import { render, staticRenderFns } from "./MailCodeDropdown.vue?vue&type=template&id=3f72c497&scoped=true"
import script from "./MailCodeDropdown.vue?vue&type=script&lang=js"
export * from "./MailCodeDropdown.vue?vue&type=script&lang=js"
import style0 from "./MailCodeDropdown.vue?vue&type=style&index=0&id=3f72c497&prod&scoped=true&lang=css"
import style1 from "./MailCodeDropdown.vue?vue&type=style&index=1&id=3f72c497&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f72c497",
  null
  
)

export default component.exports